export enum MemberEvaluationStatus {
  // This evaluation is ready to be completed.
  ReadyToComplete = 'ReadyToComplete',

  // This evaluation has already been completed.
  Complete = 'Complete',

  // The deadline for this evaluation has passed.
  Expired = 'Expired'
}
